<div *ngIf="show$ | async as show" class="movie-card" [class.movie-card-xl]="size === 'xl'">
  <div class="movie-card-image-container">
    <!-- The poster is the LCP element of every checkout step, hence `fetchpriority`. -->
    <img class="movie-card-image" [src]="show.image" [alt]="show?.title" fetchpriority="high" />
  </div>
  <div class="movie-card-content">
    <h3 class="text-md text-uppercase mb-2 mb-md-4 d-flex align-items-center flex-wrap movie-title">
      <span class="mr-2">{{ show?.title }}</span>
      <span class="pegi-icons">
        <span
          class="pegi-icon"
          *ngFor="let code of show.pegiCodes"
          [inlineSVG]="'/assets/icons/pegi/pegi-' + code + '.svg'"
        ></span>
      </span>
    </h3>
    <div class="movie-card-details">
      <span class="d-none d-md-inline">{{ 'movie.time' | transloco }}: </span
      ><span>
        {{ show.day }} <strong>{{ show.time }}</strong></span
      >

      <span class="d-none d-md-inline">{{ 'movie.cinema' | transloco }}: </span
      ><span
        >{{ show.cinema }}, <strong>{{ show.room }}</strong></span
      >
    </div>
  </div>
</div>
